export class CheckoutService {

    constructor () {
        this._checkout = {};
        this._checkoutErrors = {};
        this._formValid = {
            'billingAddress': false,
            'shippingAddress': false,
            'shippingRate': false,
            'paymentMethod': false
        };
        this._submitting = false;
        this._billingAsShipping = true;
        this._loading = false;

        let windowLocation = window.location.href;
        if(windowLocation.includes('checkout')) {
            this.reload();
        }
    }

    get () {
        return this._checkout;
    }

    set (checkout) {
        this._checkout = checkout;
        bus.$emit('checkout-changed', checkout);
    }

    getBillingAsShipping() {
      return this._billingAsShipping;
    }

    setBillingAsShipping(billingAsShipping) {
        this._billingAsShipping = billingAsShipping;
        bus.$emit('checkout-billing-as-shipping-changed', this._billingAsShipping);
    }

    getErrors () {
        return this._checkoutErrors;
    }

    setErrors(type, errors, label)
    {
        if(typeof this._checkoutErrors[type] === 'undefined') {
            this._checkoutErrors[type] = {
                'type': type,
                'errors': {}
            };
        }

        if(label) {
            this._checkoutErrors[type].label = label;
        }

        if(Object.keys(errors).length) {
            this._checkoutErrors[type].errors = $.extend({}, this._checkoutErrors[type].errors, errors);
        } else {
            this._checkoutErrors[type].errors = {};
        }


        bus.$emit('checkout-errors-changed', this._checkoutErrors, type, errors);
    }

    deleteErrors(type, errors) {
        if(typeof this._checkoutErrors[type] !== 'undefined' && typeof this._checkoutErrors[type].errors !== 'undefined') {
            for (let key in errors) {
                delete this._checkoutErrors[type].errors[key];
            }
            bus.$emit('checkout-errors-changed', this._checkoutErrors, type, errors);
        }



    }

    reload() {
        this.setLoading(true);
        axios.get('/checkout-data')
            .then(response => {
                this.setLoading(false);
                this.set(response.data);
            });
    }

    getLoading()
    {
        return this._loading;
    }

    setLoading(loading)
    {
        this._loading = loading;
        if(typeof bus !== 'undefined') {
            bus.$emit('checkout-loading', loading);
        }

    }

    submit() {
        if(false === this.isSubmitting()) {
            bus.$emit('checkout-submit');
        }
        this.setSubmitting(true);
    }

    isSubmitting() {
        return this._submitting;
    }

    setSubmitting(submitting) {
        this._submitting = submitting;

        if(submitting) {
            bus.$emit('checkout-submitting');
        } else {
            bus.$emit('checkout-not-submitting');
        }

    }

    setFormValid(type, valid) {
        this._formValid[type] = valid;
        bus.$emit('checkout-form-valid-changed', this._formValid);
    }

    resetFormValid()
    {
        for(let key in this._formValid) {
            this._formValid[key] = false
        }
    }



}